module.exports = __webpack_public_path__ + "img/connect-renewals-banner-new.b01cdf8f.png";